import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const USER_INSTALL_CONSENT_API_PATH = '/gateway/api/marketplace/internal/demand/frontend/user-app-install-consent';
/**
 * Get list of apps that user has given install consent for
 */
export const getUserInstallConsent = async headers => {
  const path = USER_INSTALL_CONSENT_API_PATH;
  const options = _objectSpread({
    method: 'GET'
  }, headers && {
    headers
  });
  try {
    const response = await fetchOk(path, options);
    const userInstallConsentResponse = await response.json();
    return userInstallConsentResponse;
  } catch (error) {
    console.error('getUserInstallConsent', 'Failed to fetch user install consent', error);
    return [];
  }
};

/**
 * Record user consent for app installation
 */
export const postUserInstallConsent = async (body, headers) => {
  const path = USER_INSTALL_CONSENT_API_PATH;
  const options = {
    method: 'POST',
    headers: _objectSpread({
      'Content-Type': 'application/json'
    }, headers),
    body: JSON.stringify(body)
  };
  try {
    await fetchOk(path, options);
  } catch (error) {
    console.error('postUserInstallConsent', 'Failed to record user install consent', error);
    throw error;
  }
};